import { Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/app/(protected)/protected-route";
import CreateNewAdmin from "@/app/(protected)/superadmin/admins/new/page";
import AllAdminsPageOfSuperAdmin from "@/app/(protected)/superadmin/admins/page";
import SuperAdminLayout from "@/app/(protected)/superadmin/layout";
import SuperAdminHomePage from "@/app/(protected)/superadmin/page";
import { EditAdminPage } from "@/app/(protected)/superadmin/admins/[adminId]/page";
import EmployeesPageForSuperAdmin from "@/app/(protected)/superadmin/employees/page";
import IndividualActivityPageOfEmployeeForSA from "@/app/(protected)/superadmin/employees/(routes)/activity/page";
import IndividualActivityPageOfAdminForSA from "@/app/(protected)/superadmin/admins/(routes)/activity/page";
import EmployeesActivityForSuperAdmin from "@/app/(protected)/superadmin/employees/(routes)/employees-activity/page";
import AdminsActivityForSuperAdmin from "@/app/(protected)/superadmin/admins/(routes)/admin-activity/page";
import LeadsActivityOfEmployees from "@/app/(protected)/superadmin/employees/(routes)/leads-activity/page";
import AttendanceReportsForEmployee from "@/app/(protected)/superadmin/employees/(routes)/attendance/page";
import AttendanceReport1OfEmployees from "@/app/(protected)/superadmin/employees/(routes)/attendance/report1/page";
import EmployeesLeavesActivity from "@/app/(protected)/superadmin/employees/(routes)/leaves/page";
import CheckinManagementPage from "@/app/(protected)/superadmin/checkin-management/page";

const SuperAdminRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<SuperAdminLayout />}>
          <Route index path="/" element={<SuperAdminHomePage />} />
          <Route path="/admins" element={<AllAdminsPageOfSuperAdmin />} />
          <Route path="/admins/new" element={<CreateNewAdmin />} />
          <Route path="/admins/:adminId" element={<EditAdminPage />} />
          <Route
            path="/admins/activity/:adminId"
            element={<IndividualActivityPageOfAdminForSA />}
          />
          <Route
            path="/admin-activity"
            element={<AdminsActivityForSuperAdmin />}
          />

          <Route path="/employees" element={<EmployeesPageForSuperAdmin />} />
          <Route
            path="/employees/activity/:empId"
            element={<IndividualActivityPageOfEmployeeForSA />}
          />
          <Route
            path="/employee-activity"
            element={<EmployeesActivityForSuperAdmin />}
          />
          <Route
            path="/employees/lead-activity"
            element={<LeadsActivityOfEmployees />}
          />
          <Route
            path="/employees/attendance-reports"
            element={<AttendanceReportsForEmployee />}
          />
          <Route
            path="/employees/attendance-reports/report1"
            element={<AttendanceReport1OfEmployees />}
          />
          <Route
            path="/employees/leaves"
            element={<EmployeesLeavesActivity />}
          />

          {/* Check-in Management */}
          <Route
            path="/checkin-management"
            element={<CheckinManagementPage />}
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default SuperAdminRoutes;
